module.exports = __webpack_public_path__ + "static/media/view-all-arrow.e4cda05c.svg";